module.exports = __webpack_public_path__ + "static/media/triangle-shape.988d7db0.svg";